import './scss/main.scss'

// import './javascript/jquery.js'
// import './javascript/owl.carousel.js'
// import './javascript/masonry.js'
// import './javascript/photoswipe.js'
// import './javascript/greensock.js'
import './javascript/noiframe.js'
import './javascript/modernizr.js'
import './javascript/detect-os.js'
import './javascript/detect-browser.js'
import './javascript/detect-mobile.js'
import './javascript/main.js'



//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 0
// module chunks = 0